import { Avatar, HStack, Icon, Text } from "@chakra-ui/react";
import { FacebookPage } from "../types";
import { getIconComponent } from "src/Manager/FeedManager/SocialInput";

interface FacebookIdentityProps {
  id?: string;
  pages?: FacebookPage[];
}

const FacebookIdentity = ({ id, pages }: FacebookIdentityProps) => {
  if (!id) return null;

  const getPageIdentityFromId = (id?: string) => {
    return pages?.find((page) => page.id === id)?.name;
  };

  return (
    <HStack>
      <Avatar size="xs" />
      <Text>{getPageIdentityFromId(id)}</Text>
      <Text color="gray.500" fontSize="xs">
        <Icon fontSize="18px" as={getIconComponent("facebook")} />
      </Text>
    </HStack>
  );
};

export default FacebookIdentity;
